module.exports = require('./helpers/bundle-url').getBundleURL('gfGbX') + "Mario_Headshot 2024015.20d20af7.png";